import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./HomeClassic.css";
import "./HomeSpeaker.css";
import "./HomeSpeakerPose.css";
import "./HomeSpeakerFloor.css";
import "./HomeSpeechBubble.css";
import "./HomeBubbleTailFix.css";
import "./HomeFinalPosition.css";

const HomeSpeaker = () => {
  const history = useHistory();
  const [lang, setLang] = useState("en");
  const [step, setStep] = useState("before");

  useEffect(() => {
    setLang(localStorage.getItem("cooldoc_lang") === "ko" ? "ko" : "en");
  }, []);

  const changeLanguage = useCallback((nextLanguage) => {
    setLang(nextLanguage);
    localStorage.setItem("cooldoc_lang", nextLanguage);
  }, []);

  return (
    <div className="container intro classic-home">
      <section className="lang-container">
        <img src="/icon/globe.svg" alt="" />
        <button className={lang === "en" ? "active" : ""} onClick={() => changeLanguage("en")}>En</button>
        <span>|</span>
        <button className={lang === "ko" ? "active" : ""} onClick={() => changeLanguage("ko")}>Ko</button>
      </section>

      <header className="classic-title-wrap">
        <h1 className="classic-whoami"><span>WHO AM I</span></h1>
        <p className="classic-identity">
          {lang === "en" ? "MBTI \u00d7 IDENTITY" : "MBTI \u00d7 \uc815\uccb4\uc131"}
        </p>
      </header>

      <div className="character-scene">
        <div className="character-speech" aria-live="polite">
          {step === "before"
            ? lang === "en"
              ? "I'm COOLDOC from another planet. I came to Earth to explore humans."
              : "\ub098\ub294 \ub2e4\ub978 \ud589\uc131\uc5d0\uc11c \uc628 COOLDOC\uc785\ub2c8\ub2e4. \uc9c0\uad6c\uc778\uc744 \ud0d0\uc0ac\ud558\uae30 \uc704\ud574 \uc9c0\uad6c\uc5d0 \uc654\uc2b5\ub2c8\ub2e4."
            : lang === "en"
            ? <>Now it's time to explore your identity.<br />Imagine you are an alien who has crash-landed on Earth.<br />Choose the response that instinctively feels most like you.</>
            : <>이제 당신의 정체를 탐사할 시간입니다.<br />지구에 불시착한 외계인이 되어,<br />각 상황에서 본능적으로 끌리는 선택을 해주세요.</>}
        </div>
        <div className="character-orbit" aria-hidden="true" />
        <img className="character-figure" src="/image/doc_standing_tight.png" alt="COOLDOC character" />
        <div className="character-platform" aria-hidden="true" />
      </div>

      <button className="cta" onClick={() => {
        if (step === "before") setStep("after");
        else history.push("/test");
      }}>
        {step === "before"
          ? lang === "en" ? "Click" : "\ud074\ub9ad"
          : lang === "en" ? "Start" : "\ud14c\uc2a4\ud2b8\ud558\uae30"}
      </button>
    </div>
  );
};

export default HomeSpeaker;
